import type { DisputeNote, UpdateDisputeNoteRequest } from '@/types/dispute-note';

/**
 * Demo-mode fabricated response for editing a dispute note.
 * Used as the demoFn for useUpdateDisputeNote.
 */
export function updateDisputeNoteDemoResponse(request: UpdateDisputeNoteRequest): DisputeNote {
  return {
    id: request.noteId,
    disputeId: request.disputeId,
    content: request.content,
    createdAt: new Date().toISOString(),
    createdBy: {
      id: '',
      name: 'Current User',
    },
  };
}
